import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=a1d90a62&scoped=true&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Phone.vue?vue&type=style&index=0&id=a1d90a62&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a1d90a62",
  "4364314e"
  
)

export default component.exports